import classNames from "classnames";
import Link from "next/link";
import getConfig from "next/config";

const {
  publicRuntimeConfig: {
    settings: { websiteName },
  },
} = getConfig();

const isBricoStore = websiteName === "bricostore";

const ProductButtonViewResealed = ({ href, isCatalog = false }) => {
  const buttonClasses = classNames(
    "bg-[#39ab4a] hover:bg-[#2d883a] active:bg-[#3cb94ee4] block w-full text-white font-medium text-center",
    {
      "py-[7px] text-sm leading-18.2": isCatalog,
      "lg:w-1/2 p-3 leading-20.8": !isCatalog,
      // Brico: pill shape (like the other brico buttons); altex/MG keep the diagonal corners
      "rounded-full": isBricoStore,
      "rounded-tr-md rounded-bl-md": !isBricoStore && isCatalog,
      "rounded-tr-lg rounded-bl-lg": !isBricoStore && !isCatalog,
    }
  );

  return (
    <Link href={href}>
      <a className={buttonClasses}>Vezi resigilate</a>
    </Link>
  );
};

export default ProductButtonViewResealed;
